<template>
  <q-bar class="bg-white">
    <div class="col text-center">{{ $t('trade.title') }}</div>
  </q-bar>
  <div v-if="loading" class="text-center">
    <q-spinner color="primary" size="3em" />
  </div>
  <div v-else>
    <div v-for="(trade, index) in trades" :key="index" class="trade q-mb-md">
      <div class="column">
        <div class="trade__tradeId col-12 q-pa-sm text-center">
          {{ $t('trade.tradesub.serno', { data: trade.serno }) }}
        </div>
        <q-img src="https://cdn.quasar.dev/img/parallax1.jpg" height="20vh" />
        <Tradesub :trade="trade" />
      </div>
    </div>
    <div
      v-if="trades.length < 1"
      class="trade--notFound text-center q-pa-xl text-h4"
    >
      {{ $t('trade.list.notFound') }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import { RESOURCE_STATE } from '@/constants';
import Tradesub from '@/views/Trade/Tradesub.vue';

export default {
  components: {
    Tradesub,
  },
  data() {
    return {
      trades: [],
      pageState: RESOURCE_STATE.IDLE,
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
    }),

    loading() {
      return this.pageState === RESOURCE_STATE.PENDING;
    },
  },
  created() {
    this.pageState = RESOURCE_STATE.PENDING;
    this.getTrades(this.personalInfo.userid)
      .then((res) => {
        let order = res.filter(x => x.state == 2 );
        console.log('order',order);
        this.trades = order;
        // this.trades = res;
        this.pageState = RESOURCE_STATE.RESOLVED;
      })
      .catch((err) => {
        console.log(err);

        this.pageState = RESOURCE_STATE.REJECTED;

        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('trade.getInfo.failed'),
          caption: err.response.data,
        });
      });
  },
  methods: {
    ...mapActions({
      getTrades: 'trade/getTrades',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.trade {
  &__tradeId {
    color: white;
    background-color: #7f7f7f;
  }

  &--notFound {
    border: 1px solid #7f7f7f;
  }
}
</style>
